import { Button } from "azure-devops-ui/Button";
import * as React from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import { TileCollection } from "../Components/TileCollection";
import { isPublicSite } from "../configuration";
import { makeFullUrl } from "../routing";
import "./Home.scss";

export default class HomePage extends React.Component {
    public render(): JSX.Element | null {
        return (
            <div className="flex-column flex-grow">
                <div className="home-main-tile flex-column">
                    <div className="home-main-tile-content flex-column">
                        <h1 className="home-main-tile-text">
                            Design and build great experiences for
                            <br />
                            Developer Services
                        </h1>
                        <div className="home-main-tile-actions">
                            <Route children={this.renderGettingStartedLink} />
                        </div>
                    </div>
                </div>
                <TileCollection
                    className="flex-wrap home-page-tiles"
                    useRowSeparators={true}
                    tiles={[
                        [
                            isPublicSite()
                                ? {
                                      description: "Guidelines for developing Azure DevOps extensions with web UI.",
                                      imageClassName: "home-page-image-tile",
                                      imageUrl: require("../Images/Home/home-basics.png"),
                                      title: "Extension development",
                                      url: "develop/extensions"
                                  }
                                : {
                                      description: "The fundamentals of the Formula design language.",
                                      imageClassName: "home-page-image-tile",
                                      imageUrl: require("../Images/Home/home-basics.png"),
                                      title: "Design basics",
                                      url: "design-basics/content"
                                  },
                            {
                                description: "The building blocks, and how to use them to create robust features.",
                                imageClassName: "home-page-image-tile",
                                imageUrl: require("../Images/Home/home-components.png"),
                                title: "Components",
                                url: "components"
                            },
                            {
                                description: "Small helpers and utilities that can be integrated with UI components.",
                                imageClassName: "home-page-image-tile",
                                imageUrl: require("../Images/Home/home-utilities.png"),
                                title: "Utilities",
                                url: "utilities"
                            }
                        ]
                    ]}
                />
            </div>
        );
    }

    private renderGettingStartedLink = (routeProps: RouteComponentProps) => {
        const url = makeFullUrl("components");
        const onClick = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>): void => {
            routeProps.history.push(url);
            event.preventDefault();
        };
        return (
            <div className="home-main-tile-button-container">
                <Button
                    className="home-main-tile-button"
                    href={url}
                    onClick={onClick}
                    ariaLabel="Get started with design and build great experiences for Developer Services"
                >
                    Get started
                </Button>
            </div>
        );
    };
}
